import { Link } from "react-router-dom"

export default function MobileSidebarDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
    const MENU_ITEMS = [
        {
            label: 'Trang chủ',
            href: '/',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/202417bcbba552f0341b2bfc8d80bf34Homepage.svg',
        },
        {
            label: 'Giới thiệu',
            href: '/gioi-thieu',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024c00d1ecfe5d2cba9321eb13a4792Feedback.svg?quality=100',
        },
        {
            label: 'Hướng dẫn đặt hàng',
            href: '/huong-dan',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/2024f28288f68a04a1f65015eae04d25H%C6%B0%E1%BB%9Bng_d%E1%BA%ABn_%C4%91%E1%BA%B7t_h%C3%A0ng.svg?quality=100',
        },
        {
            label: 'Điều khoản sử dụng',
            href: '/dieu-khoan-su-dung',
            icon: 'https://gcs.buymed.com/thuocsi-live/internal/cms/20253caab1d5935de5b5e3bab398a0e6Policy-default.svg?quality=100',
        },
    ]

    const SOCIALS = [
        { name: 'facebook', href: 'https://www.facebook.com/buymedvn', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/fb1.svg' },
        { name: 'tiktok', href: 'https://www.tiktok.com/@buymed.com', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/tiktok1.svg' },
        { name: 'linkedin', href: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/linkedin1.svg', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/linkedin1.svg' },
        { name: 'zalo', href: 'https://zalo.me/1836616064223034882', icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/menuHamburger/zalo1.svg' },
    ]

    const CERTS = [
        {
            href: 'http://online.gov.vn/Home/WebDetails/52192',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/verify_mobile.png',
        },
        {
            href: 'http://online.gov.vn/Home/AppDetails/2786',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/verify_mobile.png',
        },
        {
            href: 'https://cystack.net/projects/buymed',
            icon: 'https://cdn-web-mobile-next.thuocsi.vn/images/footer/cystack.svg',
        },
    ]


    if (!open) return null

    return (
        <div
            role="presentation"
            className="MuiDrawer-root MuiDrawer-modal styles_mobileSidebar_container__3f0CA"
            style={{ position: 'fixed', inset: 0, zIndex: 1300 }}
        >
            {/* Backdrop */}
            <div
                className="MuiBackdrop-root"
                aria-hidden="true"
                onClick={onClose}
                style={{ opacity: 1 }}
            />

            {/* Drawer */}
            <div
                className="MuiPaper-root MuiDrawer-paper MuiDrawer-paperAnchorLeft MuiPaper-elevation16"
                tabIndex={-1}
            >
                {/* MENU LIST */}
                <div className="styles_groupTable__s_bK0">

                    {MENU_ITEMS.map((item, i) => (
                        <Link
                            key={i}
                            className={`styles_mobile_rootBase__8z7PQ styles_navItem__SgbRN`}
                            to={item.href}
                            onClick={onClose}
                        >
                            <img src={item.icon} alt="" />
                            <h6 className="styles_textName__OPCtF">{item.label}</h6>
                        </Link>
                    ))}

                </div>

                {/* SOCIAL */}
                <div className="styles_groupSocialMedia__EkxTR">
                    <h6 className="styles_textSocialMedia__fMj76">Kết nối với chúng tôi</h6>
                </div>

                <div className="styles_groupSocialMedia__EkxTR">
                    {SOCIALS.map((s, i) => (
                        <a
                            key={i}
                            href={s.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="social media Link"
                        >
                            <span
                                style={{
                                    boxSizing: 'border-box',
                                    display: 'inline-block',
                                    overflow: 'hidden',
                                    width: 'initial',
                                    height: 'initial',
                                    background: 'none',
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    position: 'relative',
                                    maxWidth: '100%',
                                }}
                            >
                                <span
                                    style={{
                                        boxSizing: 'border-box',
                                        display: 'block',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: '100%',
                                    }}
                                >
                                    <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='24'%20height='24'/%3e"
                                        style={{
                                            display: 'block',
                                            maxWidth: '100%',
                                            width: 'initial',
                                            height: 'initial',
                                            background: 'none',
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                        }}
                                    />
                                </span>

                                <img
                                    alt={s.name}
                                    src={s.icon}
                                    decoding="async"
                                    style={{
                                        position: 'absolute',
                                        inset: 0,
                                        boxSizing: 'border-box',
                                        padding: 0,
                                        border: 'none',
                                        margin: 'auto',
                                        display: 'block',
                                        width: 0,
                                        height: 0,
                                        minWidth: '100%',
                                        maxWidth: '100%',
                                        minHeight: '100%',
                                        maxHeight: '100%',
                                    }}
                                />
                            </span>
                        </a>
                    ))}
                </div>

                {/* CERTIFICATE */}
                <div className="styles_groupCertificateIcons__wPSGG">
                    {CERTS.map((c, i) => (
                        <a
                            key={i} href={c.href}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Certificate Link"
                        >
                            <div className="styles_mt2__nKIhj">
                                <span
                                    style={{
                                        boxSizing: 'border-box',
                                        display: 'inline-block',
                                        overflow: 'hidden',
                                        width: 'initial',
                                        height: 'initial',
                                        background: 'none',
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: 'relative',
                                        maxWidth: '100%',
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: 'border-box',
                                            display: 'block',
                                            width: 'initial',
                                            height: 'initial',
                                            background: 'none',
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: '100%',
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='85'%20height='26'/%3e"
                                            style={{
                                                display: 'block',
                                                maxWidth: '100%',
                                                width: 'initial',
                                                height: 'initial',
                                                background: 'none',
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0,
                                            }}
                                        />
                                    </span>

                                    <img
                                        src={c.icon}
                                        decoding="async"
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            boxSizing: 'border-box',
                                            padding: 0,
                                            border: 'none',
                                            margin: 'auto',
                                            display: 'block',
                                            width: 0,
                                            height: 0,
                                            minWidth: '100%',
                                            maxWidth: '100%',
                                            minHeight: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'contain',
                                        }}
                                        alt=""
                                    />
                                </span>
                            </div>
                        </a>

                    ))}
                </div>
            </div>
        </div>
    )
}
